import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { SENHA_MINIMA } from '../utils/erroDeAuth';
import GraficoDoLogo from './GraficoDoLogo';
import CampoDeSenha from './CampoDeSenha';
import './LoginPage.css';

/**
 * Escolher a senha nova — a tela para quem chegou pelo link do email (05/10).
 *
 * O link de recuperação entra com uma sessão de verdade. Sem esta tela o app
 * abriria como num login comum, e a pessoa — que clicou no link justamente
 * para trocar a senha — não teria onde fazer isso.
 *
 * Serve aos dois casos com o mesmo formulário: quem esqueceu, e quem sempre
 * entrou com o Google e está criando a primeira senha. Nos dois a senha passa
 * a valer para a MESMA conta, com os mesmos dados.
 *
 * Pede a senha duas vezes porque não há como conferir depois: o erro de
 * digitação aqui só aparece no próximo login, como "senha incorreta".
 */
const DefinirSenha: React.FC = () => {
  const { definirSenha, signOut } = useAuth();
  const [senha, setSenha] = useState('');
  const [repetida, setRepetida] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [ocupado, setOcupado] = useState(false);

  const salvar = async (e: React.FormEvent) => {
    e.preventDefault();
    if (senha.length < SENHA_MINIMA) return setErro(`A senha precisa ter pelo menos ${SENHA_MINIMA} caracteres.`);
    if (senha !== repetida) return setErro('As duas senhas não estão iguais.');
    setOcupado(true);
    setErro(null);
    const falha = await definirSenha(senha);
    setOcupado(false);
    if (falha) setErro(falha);
  };

  return (
    <div className="login-page">
      <GraficoDoLogo variante="login" />
      <div className="login-card">
        <form className="login-form" onSubmit={salvar} noValidate>
          <h1 className="login-form-titulo">Escolha uma senha nova</h1>
          <p className="login-form-intro">
            Ela passa a valer para a sua conta, junto com o que você já usa para entrar.
          </p>
          <CampoDeSenha
            rotulo="Senha nova" valor={senha} aoMudar={setSenha} autoComplete="new-password"
            desabilitado={ocupado} minLength={SENHA_MINIMA} autoFocus
            dica={`Pelo menos ${SENHA_MINIMA} caracteres.`}
          />
          <CampoDeSenha
            rotulo="Repita a senha" valor={repetida} aoMudar={setRepetida} autoComplete="new-password"
            desabilitado={ocupado}
          />
          {erro && <p className="login-erro" role="alert">{erro}</p>}
          <button className="login-enviar" disabled={ocupado} aria-busy={ocupado}>Salvar e entrar</button>
          <div className="login-links">
            {/* Sair, e não "agora não": ficar logada sem ter trocado a senha
                seria o link de recuperação funcionando como login sem senha. */}
            <button type="button" className="login-link" onClick={() => void signOut()}>Cancelar e sair</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DefinirSenha;
